import Vue from 'vue'
import apiList from '@/service/apiList'
import { Message } from 'element-ui'
/* eslint-disable no-undef */
const cbhost = cbhostname

// 获取商城分类
function getMallClassifyList () {
  let params = {
    rg_id: 'web',
    rg_ver: '9999'
  }
  return new Promise((resolve) => {
    Vue.prototype.$api.post(cbhost + '/v0.2/brand/get_channel_all', params)
      .then(function (res) {
        resolve(res.data)
      })
      .catch(function (err) {
        console.log(err)
      })
  })
}
// 获取我的分类
function getMyClassifyList (params) {
  return new Promise((resolve) => {
    Vue.prototype.$api.get(apiList.classifyList, params)
      .then(function (res) {
        resolve(res.data)
      })
      .catch(function (err) {
        console.log(err)
      })
  })
}
// 保存分类
function saveMyClassifyList (params) {
  return new Promise((resolve) => {
    Vue.prototype.$api.post(apiList.addClassify, params)
      .then(function (res) {
        if (res.message === 'Success') {
          Message.success('保存成功')
        }
        resolve(res.data)
      })
      .catch(function (err) {
        console.log(err)
      })
  })
}

export {getMallClassifyList, getMyClassifyList, saveMyClassifyList}



// WEBPACK FOOTER //
// ./src/models/classifyModel.js